var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',_vm._b({attrs:{"outlined":"","dense":"","items":_vm.entries,"loading":_vm.loading,"label":"Select Role","value":_vm.value,"item-text":"name","item-value":"id"},on:{"input":_vm.emitVal}},'v-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }